/**
 * 增值服务 API 汇总
 * 仅包含本项目特有或覆盖公共库的接口
 */
export default {
  name: 'increment',

  /**
   * 最近任务列表接口
   */
  GetPushTaskList: {
    url: '/das-manager/api/push/task/pushTaskList'
  },

  // 推送任务列表导出
  ExportPushTaskList: {
    url: '/das-manager/api/push/task/exportList'
  },

  /**
   * 白名单相关接口
   */
  // 获取导入任务列表
  GetWhitelistTaskList: {
    url: '/das-manager/api/excelTask/whileList'
  },
  // 分页获取白名单学者列表
  GetWhitelist: {
    url: '/das-manager/api/whiteUser/list'
  },
  // 删除白名单学者
  DeleteWhitelistAuthor: {
    url: '/das-manager/api/whiteUser/delete'
  },
  // 导入白名单
  ImportWhitelist: {
    url: '/das-manager/api/whiteUser/upload'
  },
  // 下载白名单模板
  DownloadWhitelistTemplate: {
    url: '/das-manager/api/excelTask/templateDownload'
  },
  ExportWhiteUser: {
    url: '/das-manager/api/whiteUser/export'
  },
  // 获取导入失败文件下载地址
  GetFailFileUrl: {
    url: '/das-manager/api/push/config/getFileUrl'
  },
  // 基础设置-推送设置-获取推送配置
  GetPushConfig: {
    url: '/das-manager/api/push/config/getConfig'
  },
  // 基础设置-推送设置-更新推送配置
  UpdatePushConfig: {
    url: '/das-manager/api/push/config/update'
  },
  //邮件推送-基础配置-期刊邮件推送改变
  UpdateSendCount: {
    url: '/das-api/push/mag/config/update'
  },
  //邮件推送-基础配置-期刊邮件推送期刊选择查询
  GetMagChioceList: {
    url: '/das-api/vas/push/mag/mag/set/getChioce'
  },
  //邮件推送-基础配置-期刊邮件推送机构选择查询
  GetOrgChioceList: {
    url: '/das-api/vas/push/mag/org/set/getChioce'
  },
  // 推送设置-自定义推送期刊-模糊查询
  GetMagFilterChioceList: {
    url: '/das-manager/api/push/mag/mag/set/getChioce'
  },
  // 推送设置-自定义推送机构-模糊查询
  GetOrgFilterChioceList: {
    url: '/das-manager/api/push/mag/org/set/getChioce'
  },
  //邮件推送-基础配置-期刊邮件推送期刊设置
  SetMagChioce: {
    url: '/das-api/vas/push/mag/mag/set/set'
  },
  //邮件推送-基础配置-期刊邮件推送期刊查询
  GetMagChioce: {
    url: '/das-api/vas/push/mag/mag/set/get'
  },
  // 推送设置-自定义推送期刊保存
  SetMagFilterChioce: {
    url: '/das-manager/api/push/mag/mag/set/set'
  },
  // 推送设置-自定义推送期刊查询
  GetMagFilterChioce: {
    url: '/das-manager/api/push/mag/mag/set/get'
  },
  //邮件推送-基础配置-期刊邮件推送机构设置
  SetOrgChioce: {
    url: '/das-api/vas/push/mag/org/set/set'
  },
  //邮件推送-基础配置-期刊邮件推送机构查询
  GetOrgChioce: {
    url: '/das-api/vas/push/mag/org/set/get'
  },
  // 推送设置-自定义推送机构保存
  SetOrgFilterChioce: {
    url: '/das-manager/api/push/mag/org/set/set'
  },
  // 推送设置-自定义推送机构查询
  GetOrgFilterChioce: {
    url: '/das-manager/api/push/mag/org/set/get'
  },
  // 邮件推送-基础配置-删除推送机构
  DeleteOrgChioce: {
    url: '/das-api/vas/push/mag/org/set/delete'
  },
  // 邮件推送-期刊邮件精准推送设置查询
  GetAccurateConfigList: {
    url: '/das-api/push/mag/accurate/config/getByMagId'
  },
  // 邮件推送-期刊邮件精准推送设置保存
  SaveAccurateConfig: {
    url: '/das-api/push/mag/accurate/config/save'
  },
  // 邮件推送-配置推送期刊机构阈值
  updatePushMagCustomValue: {
    url: '/das-api/push/mag/config/updatePushMagCustomValue'
  },
  // 邮件推送-查看阈值
  getSeuilSetting: {
    url: '/das-api/vas/push/getLimitNumber'
  },
  //邮件推送-基础配置-期刊邮件推送期刊分类设置
  GetMagZxsList: {
    url: '/das-api/vas/push/mag/config/searchMagZxsCat'
  },
  // 上传封面
  UploadPictureStream: {
    url: '/das-api/vas/push/configManage/uploadBanner'
  },
  // 获取封面
  GetPictureStream: {
    url: '/das-api/vas/push/configManage/getPictureStream'
  },
  // 基础配置-发件邮箱管理列表查询
  GetEmailList: {
    url: '/das-manager/api/magEmail/list'
  },
  // 基础配置-发件邮箱管理邮箱编辑
  EditEmail: {
    url: '/das-manager/api/magEmail/edit'
  },
  // 基础配置-发件邮箱管理邮箱删除
  DeleteEmail: {
    url: '/das-manager/api/magEmail/delete'
  },
  // 基础配置-发件邮箱管理邮箱新增/保存
  SaveEmail: {
    url: '/das-manager/api/magEmail/save'
  },
  // 基础配置-发件邮箱管理邮箱排序
  SortEmail: {
    url: '/das-manager/api/magEmail/sequence/sort'
  },
  // 基础配置-模板管理列表查询
  GetTemplateList: {
    url: '/das-manager/api/magTemplate/list'
  },
  // 基础配置-模板管理设置默认模板
  SetDefaultTemplate: {
    url: '/das-manager/api/magTemplate/setDefault'
  },
  // 基础配置-模板管理新增/保存
  SaveTemplate: {
    url: '/das-manager/api/magTemplate/create'
  },
  // 基础配置-模板管理编辑/保存
  EditTemplate: {
    url: '/das-manager/api/magTemplate/edit'
  },
  // 基础配置-模板管理删除
  DeleteTemplate: {
    url: '/das-manager/api/magTemplate/delete'
  },
  // 基础配置-模板管理-模板风格列表查询
  GetTemplateStyleList: {
    url: '/das-manager/api/sysTemplateStyle/list'
  },
  // 六个步骤-论文列表-获取论文列表
  GetPaperList: {
    url: '/das-manager/api/push/task/article/list'
  },
  // 六个步骤-论文列表-论文排序
  SortPaper: {
    url: '/das-manager/api/push/task/article/sequence/sort'
  },
  // 六个步骤-论文列表-论文删除
  DeletePaper: {
    url: '/das-manager/api/push/task/article/delete'
  },
  // 文件上传
  UploadTemplateConfig: {
    url: '/das-manager/api/push/config/uploadConfig'
  },
  // 图片预览
  GetConfigPicture: {
    url: '/das-manager/api/push/config/picture'
  },
  // 六个步骤-获取任务推送模板
  GetTaskPushTemplate: {
    url: '/das-manager/api/task/template/getList'
  },
  // 六个步骤-试推送
  TryPush: {
    url: '/das-manager/api/task/push/trySend'
  },
  // 六个步骤-正式推送
  OfficialPush: {
    url: '/das-manager/api/task/push/send'
  },
  // 六个步骤-获取手机校验码
  GetSmsVerifyCode: {
    url: '/das-manager/api/verifyCode/smsCode'
  },
  // 基础配置-模板管理-模板详情查询
  GetTemplateDetail: {
    url: '/das-manager/api/magTemplate/detail'
  },
  // 基础配置-模板管理-模板详情查询-任务
  GetDetailForTask: {
    url: '/das-manager/api/magTemplate/detailForTask'
  },
  // 模板-启用禁用状态
  EnableTemplate: {
    url: '/das-manager/api/magTemplate/enable'
  },
  // 遴选学者-获取默认推送配置
  GetDefaultPushConfig: {
    url: '/das-manager/api/push/set/getDefault'
  },
  // 遴选学者-获取任务的选择配置
  GetAuthorChoice: {
    url: '/das-manager/api/push/set/getAuthorChoice'
  },
  // 遴选学者-获取任务的选择配置
  GetPushSubjectAuthorChoice: {
    url: '/das-manager/api/pushSubject/getAuthorChoice'
  },
  // 遴选学者-获取任务的推送配置
  GetSendVersionGroupType: {
    url: '/das-manager/api/push/task/getSendVersion/groupType'
  },
  // 遴选学者-保存学者选择
  SaveAuthorChoice: {
    url: '/das-manager/api/push/set/saveAuthorChoice'
  },
  // 遴选学者-保存学者选择
  SavePushSubjectAuthorChoice: {
    url: '/das-manager/api/pushSubject/saveAuthorChoice'
  },
  // 遴选学者-获取筛选配置
  GetFilterConfig: {
    url: '/das-manager/api/push/set/getFilter'
  },
  // 遴选学者-保存筛选配置
  SaveFilterConfig: {
    url: '/das-manager/api/push/set/upsertFilter'
  },
  // 遴选学者-获取筛选配置
  GetPushSubjectFilterConfig: {
    url: '/das-manager/api/pushSubject/getFilter'
  },
  // 遴选学者-保存筛选配置
  SavePushSubjectFilterConfig: {
    url: '/das-manager/api/pushSubject/upsertFilter'
  },
  // 遴选学者-获取任务详情
  GetTaskDetail: {
    url: '/das-manager/api/push/task/detail'
  },
  // 邮件模板预览
  GetTaskPushTemplatePreview: {
    url: '/das-web-c/api/push/template/preview'
  },
  // 主题预览
  GetPushSubjectPreview: {
    url: '/das-web-c/api/push/subject/preview'
  },
  // 被引推送邮件预览
  GetPushCitationPreview: {
    url: '/das-web-c/api/push/citation/preview'
  },
  // 任务模板详情查询
  GetTaskTemplateDetail: {
    url: '/das-manager/api/task/template/detail'
  },
  // 任务模板编辑保存
  EditTaskTemplate: {
    url: '/das-manager/api/task/template/edit'
  },
  // 任务新建保存
  CreateTask: {
    url: '/das-manager/api/push/task/create'
  },
  // 任务删除
  DeleteTask: {
    url: '/das-manager/api/push/task/delete'
  },
  // 获取论文版本库列表
  GetIssueArticles: {
    url: '/das-manager/api/push/task/article/getIssueArticles'
  },
  // 获取年期数据
  GetYearIssues: {
    url: '/das-manager/api/push/task/article/getYearIssues'
  },
  // 获取文章栏目
  GetArticleColumn: {
    url: '/das-manager/api/push/task/article/getArticleColumn'
  },
  // 论文检索
  SearchArticle: {
    url: '/das-manager/api/push/task/article/search'
  },
  // 论文检索-索引
  SearchArticleIndex: {
    url: '/das-manager/api/push/task/article/search/index'
  },
  // 保存论文
  SaveArticle: {
    url: '/das-manager/api/push/task/article/saveArticle'
  },
  // 整期论文重置
  ResetIssue: {
    url: '/das-manager/api/push/task/article/resetIssue'
  },
  // 更新任务
  UpdateTask: {
    url: '/das-manager/api/push/task/update'
  },
  // 获取论文类型
  GetPaperType: {
    url: '/das-manager/api/cma/docType'
  },
  // 医学会获取学科
  GetSubject: {
    url: '/das-manager/api/cma/subject'
  },
  // 查看学者页面
  GetAuthorTaskInfo: {
    url: '/das-manager/api/push/task/authorTaskInfo'
  },
  // 查看学者页面-学者分布详情
  GetAuthorDistribution: {
    url: '/das-manager/api/taskAuthor/countByTypeDetail'
  },
  // 查看学者页面-学者分布
  GetPushMagAuthorSourceType: {
    url: '/das-manager/api/taskAuthor/countByType'
  },
  // 查看学者页面-目标用户机构分布
  GetPushMagAuthorOrg: {
    url: '/das-manager/api/taskAuthor/getPushMagAuthorOrg'
  },
  // 目标用户来源期刊分布
  GetPushMagAuthorMag: {
    url: '/das-manager/api/taskAuthor/getPushMagAuthorMag'
  },
  // 效果对比-按 historyId 与单个规则组条件统计命中且已推送成功的学者人数
  GetABTestCount: {
    url: '/das-manager/api/taskAuthor/abtest/count'
  },
  // 效果对比-对比规则A与规则B两组的推送人数、打开人数与打开率
  GetABTestCompare: {
    url: '/das-manager/api/taskAuthor/abtest/compare'
  },
  // 刷新学者
  CalculateAuthor: {
    url: '/das-manager/api/push/author/calculate'
  },
  // 获取任务推送版本列表
  GetPushedVersions: {
    url: '/das-manager/api/push/task/pushedVersions'
  },
  // 医学会论文检索-检索范围-获取集群 id
  GetMagGroupList: {
    url: '/das-manager/api/magGroup/listByPlatId'
  },
  // 获取主题列表
  GetTopicList: {
    url: '/das-manager/api/pushSubject/list'
  },
  // 新建主题
  CreateTopic: {
    url: '/das-manager/api/pushSubject/create'
  },
  // 编辑主题
  EditTopic: {
    url: '/das-manager/api/pushSubject/edit'
  },
  // 删除主题
  DeleteTopic: {
    url: '/das-manager/api/pushSubject/delete'
  },
  // 启用禁用主题
  EnableTopic: {
    url: '/das-manager/api/pushSubject/enable'
  },
  // 导出所有主题
  ExportAllTopics: {
    url: '/das-manager/api/pushSubject/export'
  },
  // 导入主题
  ImportTopics: {
    url: '/das-manager/api/pushSubject/import'
  },
  // 下载导入主题模板
  DownloadImportTemplate: {
    url: '/das-manager/api/excelTask/templateDownload?code=PUSH_SUBJECT'
  },
  // 推荐主题
  RecommendTopics: {
    url: '/das-manager/api/cma/recommendTopics'
  },
  // 查询算法配置
  GetDefaultSetChoice: {
    url: '/das-manager/api/push/set/getDefaultSetChoice'
  },
  // 查询算法配置-获取默认推送配置规则列表
  GetDefaultSetChoiceRule: {
    url: '/das-manager/api/push/set/listDefaultSetChoiceRule'
  },
  // 编辑算法配置
  SaveDefaultSetChoice: {
    url: '/das-manager/api/push/set/saveDefaultSetChoice'
  },
  // 获取整期推送期刊列表
  GetMagPushStats: {
    url: '/das-manager/api/magStats/issue-push-stats'
  },
  // 导出整期推送期刊列表
  ExportMagPushStats: {
    url: '/das-manager/api/magStats/issue-push-stats/export'
  },
  // 获取整期推送期刊列表-获取期刊名称列表
  GetMagNameList: {
    url: '/das-manager/api/push/task/magNameList'
  },
  // 获取推送列表-推送单位
  GetTenantNameList: {
    url: '/das-manager/api/push/task/tenantNameList'
  },
  // 被引订阅-分类
  GetJournalSeriesList: {
    url: '/das-manager/api/cma/journalSeries'
  },
  // 被引订阅-职称
  GetProfTitleList: {
    url: '/das-manager/api/cma/profTitle'
  },
  // 自动计算
  InitRecommendArticle: {
    url: '/das-manager/api/push/task/initRecommendArticle'
  },
  // 被引推送-效果预览
  GetPreviewPaperList: {
    url: '/das-manager/api/push/task/citation/papers'
  },
  // 期刊配置列表
  GetMailBalance: {
    url: '/das-manager/api/asis/mail-balance'
  },
  // 期刊配置详情
  GetMailBalanceDetail: {
    url: '/das-manager/api/asis/mail-balance/detail'
  },
  // 邮件推送概览
  GetActivePushPreview: {
    url: '/das-asis/api/workbench/email-push-overview'
  },
  // 邮件推送趋势
  GetActivePushTrend: {
    url: '/das-asis/api/workbench/email-push-trend'
  },
  // 邮件推送-读取区域排名
  GetEmailReadAreaRank: {
    url: '/das-asis/api/workbench/email-read-area-rank'
  },
  // 邮件推送-推送用户分析
  GetEmailUserRank: {
    url: '/das-asis/api/push-task-effect/push-user-analysis'
  },
  // 推送用户来源分布
  GetEmailUserSourceRank: {
    url: '/das-asis/api/push-task-effect/push-user-source-rank'
  },
  // 推送用户机构分布
  GetEmailUserOrgRank: {
    url: '/das-asis/api/push-task-effect/push-user-org-rank'
  },
  // 推送用户期刊分布
  GetEmailUserJournalRank: {
    url: '/das-asis/api/push-task-effect/push-user-journal-rank'
  },
  // 传播路径分析
  GetEmailPropagationPathRank: {
    url: '/das-asis/api/push-task-effect/read-email-area-rank'
  },
  // 文献阅读排行
  GetEmailReadArticleRank: {
    url: '/das-asis/api/push-task-effect/article-read-rank'
  },
  // 文献阅读排行-机构分布
  GetEmailReadArticleOrgRank: {
    url: '/das-asis/api/push-task-effect/read-article-org-rank'
  },
  // 阅读文献用户期刊分布
  GetReadArticleJournalRank: {
    url: '/das-asis/api/push-task-effect/read-article-journal-rank'
  },
  // 白名单用户分析
  GetWhiteUserRank: {
    url: '/das-asis/api/push-task-effect/white-user-analysis'
  },
  // 白名单用户活跃度排行
  GetWhiteUserActiveRank: {
    url: '/das-asis/api/push-task-effect/white-user-active-rank'
  },
  // 阅读邮件用户机构分布
  GetEmailReadOrgRank: {
    url: '/das-asis/api/push-task-report/read-email-org-rank'
  },
  // 阅读邮件用户期刊分布
  GetEmailReadJournalRank: {
    url: '/das-asis/api/push-task-report/read-email-journal-rank'
  },
  // 用户活跃度排行
  GetUserActiveRank: {
    url: '/das-asis/api/push-task-effect/user-active-rank'
  },
  // 导出数据
  ExportMedNexusAnalysis: {
    url: '/das-asis/api/bi/analysis/med-nexus/export'
  },
  // 导出数据
  ExportAnalysis: {
    url: '/das-asis/api/bi/analysis/export'
  },
  // 推送引流分析
  GetPushTrafficAnalysis: {
    url: '/das-asis/api/push-task-report/push-traffic-analysis'
  },
  // 热门栏目分析
  GetHotColumnAnalysis: {
    url: '/das-asis/api/push-task-report/hot-column-analysis'
  },
  // 阅读邮件用户地域分布
  GetEmailReadUserRegionList: {
    url: '/das-asis/api/push-task-report/read-email-area-rank'
  },
  // 年度报告-------------------------------
  // 邮件推送概况
  GetAnnualEmailPushPreview: {
    url: '/das-asis/api/annual-report/email-push-overview'
  },
  // 邮件推送传播分析
  GetAnnualEmailSpreadAnalysis: {
    url: '/das-asis/api/annual-report/email-spread-analysis'
  },
  // 热门主题分析
  GetHotTopicAnalysis: {
    url: '/das-asis/api/annual-report/hot-topic-rank'
  },
  // 热门专题分析
  GetHotSpecialtyAnalysis: {
    url: '/das-asis/api/annual-report/hot-specialty-rank'
  },
  // 文献阅读top10
  GetAnnualReadArticleRank: {
    url: '/das-asis/api/annual-report/article-read-rank'
  },
  // 文献类型阅读量Top10
  GetAnnualReadArticleTypeRank: {
    url: '/das-asis/api/annual-report/doc-type-read-rank'
  },
  // 医学统计接口
  GetMedNexusAnalysis: {
    url: '/das-asis/api/bi/analysis/med-nexus/query'
  },
  // 年度报告-邮件推送用户机构分布
  GetAnnualPushUserOrgRank: {
    url: '/das-asis/api/annual-report/push-user-org-rank'
  },
  // 年度报告-邮件推送用户期刊分布
  GetAnnualPushUserJnlRank: {
    url: '/das-asis/api/annual-report/push-user-journal-rank'
  },
  // 年度报告-阅读邮件用户地域分布
  GetAnnualReadEmailAreaRank: {
    url: '/das-asis/api/annual-report/read-email-area-rank'
  },
  // 年度报告-文献被引排行TOP10
  GetAnnualArticleCitedRank: {
    url: '/das-asis/api/annual-report/article-cited-rank'
  },
  // 年度报告-发文机构被引排行TOP10
  GetAnnualArticleOrgCitedRank: {
    url: '/das-asis/api/annual-report/article-org-cited-rank'
  },
  // 年度报告-引证期刊引证量排行TOP10
  GetAnnualArticleJournalCitedRank: {
    url: '/das-asis/api/annual-report/article-journal-cited-rank'
  },
  // 年度报告-阅读邮件用户来源机构
  GetAnnualReadEmailOrgRank: {
    url: '/das-asis/api/annual-report/read-email-org-rank'
  },
  // 年度报告-期刊阅读量Top10
  GetAnnualJournalReadRank: {
    url: '/das-asis/api/annual-report/journal-read-rank'
  },
  // 年度报告-阅读邮件用户学科分布
  GetAnnualReadEmailSubjectRank: {
    url: '/das-asis/api/annual-report/read-email-subject-rank'
  },
  // 年度报告-阅读邮件用户来源期刊
  GetAnnualReadEmailJournalRank: {
    url: '/das-asis/api/annual-report/read-email-journal-rank'
  },
  // 医学会统计
  GetSubscriptionStats: {
    url: '/das-asis/api/bi/analysis/query'
  },
  // 推送分析-数据概览
  GetEmailPushAnalysis: {
    url: '/das-asis/api/subscription-stats/push-analysis'
  },
  // 被引订阅分析-数据概览
  GetCitationAlertAnalysis: {
    url: '/das-asis/api/subscription-stats/citation-alert-analysis'
  },
  // 子期刊列表
  GetChildMagazines: {
    url: '/das-manager/api/magGroup/listChildMagazines'
  },
  // 推送用户数量
  GetPushUserCount: {
    url: '/das-asis/api/user-analysis/push-user-count'
  },
  // 已送达用户数量
  GetDeliveredUserCount: {
    url: '/das-asis/api/user-analysis/delivered-user-count'
  },
  // 已激活用户数量
  GetActivatedUserCount: {
    url: '/das-asis/api/user-analysis/activated-user-count'
  },
  // 活跃用户数量
  GetActiveUserCount: {
    url: '/das-asis/api/user-analysis/active-user-count'
  },
  // 退订用户
  GetUnsubscribeUserCount: {
    url: '/das-asis/api/user-analysis/unsubscribe-user-count'
  },
  // 主动推送送达用户
  GetActivePushUserCount: {
    url: '/das-asis/api/user-analysis/active-push/delivered-user-count'
  },
  // 主动推送已激活用户
  GetActivePushActivatedUserCount: {
    url: '/das-asis/api/user-analysis/active-push/activated-user-count'
  },
  // 主动推送活跃用户
  GetActivePushActiveUserCount: {
    url: '/das-asis/api/user-analysis/active-push/active-user-count'
  },
  // 主动推送取消订阅用户
  GetActivePushUnsubscribeUserCount: {
    url: '/das-asis/api/user-analysis/active-push/unsubscribe-user-count'
  },
  // 订阅推送送达用户
  GetActivePushSubscribeUserCount: {
    url: '/das-asis/api/user-analysis/subscription-push/delivered-user-count'
  },
  // 订阅推送激活用户
  GetSubscriptionPushActivatedUserCount: {
    url: '/das-asis/api/user-analysis/subscription-push/activated-user-count'
  },
  // 订阅推送活跃用户
  GetSubscriptionPushActiveUserCount: {
    url: '/das-asis/api/user-analysis/subscription-push/active-user-count'
  },
  // 订阅推送退订人数
  GetSubscriptionPushUnsubscribeUserCount: {
    url: '/das-asis/api/user-analysis/subscription-push/unsubscribe-user-count'
  },
  // 用户分析-推送用户机构分布(type：push-推送、delivered-送达、activated-激活、active-活跃、unsubscribe-退订 机构分布)
  GetPushUserOrgRank: {
    url: '/das-asis/api/user-analysis/user-org-rank'
  },
  // 用户分析-推送用户学科分布(type：push-推送、delivered-送达、activated-激活、active-活跃、unsubscribe-退订 学科分布)
  GetPushUserSubjectRank: {
    url: '/das-asis/api/user-analysis/user-subject-rank'
  },
  // 用户分析-推送用户年龄分布
  GetPushUserAgeRank: {
    url: '/das-asis/api/user-analysis/push-user-age-rank'
  },
  // 推送用户职称分布
  GetPushUserProfessionalRank: {
    url: '/das-asis/api/user-analysis/push-user-professional-rank'
  },
  // 推送用户国内地域分布
  GetPushUserDomesticAreaRank: {
    url: '/das-asis/api/user-analysis/push-user-area-rank/domestic'
  },
  // 推送用户国际地域分布
  GetPushUserInternationalAreaRank: {
    url: '/das-asis/api/user-analysis/push-user-area-rank/international'
  },
  // 用户分析-各种类型活跃度排行(type：push-推送、delivered-送达、activated-激活、active-活跃)
  GetPushUserRank: {
    url: '/das-asis/api/user-analysis/user-rank'
  },
  // 用户分析-用户行为数据分析
  GetUserBehaviorList: {
    url: '/das-asis/api/user-analysis/user-behavior-list'
  },
  // 推送邮件列表
  GetUserSendEmailList: {
    url: '/das-asis/api/user-analysis/user-send-email-list'
  },
  // 打开邮件列表
  GetUserOpenEmailList: {
    url: '/das-asis/api/user-analysis/user-open-email-list'
  },
  // 阅读文献列表
  GetUserReadEmailList: {
    url: '/das-asis/api/user-analysis/user-read-article-list'
  },
  // 退订详情页
  GetUserUnsubscribeEmailList: {
    url: '/das-asis/api/user-analysis/unsubscribe-email-list'
  },
  // 数据概览
  GetEmailPushOverview: {
    url: '/das-asis/api/workbench/email-push-overview'
  },
  // 数据趋势
  GetEmailPushTrend: {
    url: '/das-asis/api/workbench/email-push-trend'
  },
  // 获取magId
  GetMagByPlatId: {
    url: '/das-manager/api/mag/getMagByPlatId'
  },
  // 推送渠道分布
  GetPushChannelDistribution: {
    url: '/das-asis/api/push-distribution/channel'
  },
  // 推送类型分布
  GetPushTypeDistribution: {
    url: '/das-asis/api/push-distribution/type'
  },
  // 主动推送分布
  GetActivePushDistribution: {
    url: '/das-asis/api/push-distribution/active'
  },
  // 订阅推送分布
  GetSubscriptionPushTestDistribution: {
    url: '/das-asis/api/push-distribution/subscription'
  },
  // 文章详情-引证文献列表
  getBassApiGetData: {
    url: '/das-asis/baas-api/v1/getData'
  },

  // 微信推送 数据概览
  getWechatPushOverview: {
    url: '/das-asis/api/wechat-push-stats/overview'
  },
  // 模板风格-可编辑内容
  getEditableParts: {
    url: '/das-manager/api/sysTemplateStyle/editableParts'
  },
  // 模板风格-保存可编辑内容
  saveEditableParts: {
    url: '/das-manager/api/sysTemplateStyle/saveEditableParts'
  },
  // 获取默认筛选条件
  getDefaultFilter: {
    url: '/das-manager/api/push/set/getDefaultFilter'
  },
  // 保存默认筛选条件
  upsertDefaultFilter: {
    url: '/das-manager/api/push/set/upsertDefaultFilter'
  },
  // 获取服务有效期,是否是发布同步
  getCrawlMagId: {
    url: '/das-manager/api/mag/getCrawlMag'
  },
  // 导入学者
  importAuthorList: {
    url: '/das-manager/api/push/author-import/import'
  },
  // 被引订阅-引证文献列表
  GetCitedArticleList: {
    url: '/das-manager/api/cma/citedArticleList'
  },
  // 文章详情
  GetArticleDetail: {
    url: '/das-manager/api/cma/articleDetail'
  },
  // 设置默认推送方式
  setDefaultSetChoiceRule: {
    url: '/das-manager/api/push/set/setDefaultSetChoiceRule'
  },
  // 取消默认推送方式
  cancelDefaultSetChoiceRule: {
    url: '/das-manager/api/push/set/cancelDefaultSetChoiceRule'
  },
  // 学者中图分类
  getCategoryTree: {
    url: '/das-manager/api/push/set/categoryTree'
  },
  // 推送论文详情
  GetPushTaskDetail: {
    url: '/das-manager/api/push/task/article/detail'
  },
  // 推送论文编辑
  EditPushTask: {
    url: '/das-manager/api/push/task/article/edit'
  },
  // 查看单个条件学者人数
  GetAuthorCountByChoice: {
    url: '/das-manager/api/push/set/countByChoice'
  },
  // 获取所有期刊收录过滤器
  GetAllMagFilter: {
    url: '/das-manager/api/push/set/getAllMagFilter'
  },
  // 设置推送期刊范围
  setZxsFilter: {
    url: '/das-manager/api/push/set/setZxsFilter'
  },
  // 设置默认推送期刊范围
  setDefaultZxsFilter: {
    url: '/das-manager/api/push/set/setDefaultZxsFilter'
  }
}
